export const getAnswerImages = (formDefinition, imageToEdit) => {
  let images = [];
  formDefinition.answers.forEach(answer => {
    images = images.concat(
      answer.images.filter(ai => ai && !images.find(i => i && i.formQaImageId === ai.formQaImageId)),
    );
  });
  if (imageToEdit) {
    const exists = images.find(i => i.formQaImageId === imageToEdit.formQaImageId);
    if (!exists) {
      images = images.concat(imageToEdit);
    }
  }
  return images;
};

export const getInitialTextValue = formDefinition =>
  formDefinition.answers.length !== 0 && formDefinition.answers[0].text !== null ? formDefinition.answers[0].text : '';

export const multiSelectIsChecked = (formDefinition, imageToEdit, answerValueId, formDefinitionId) => {
  const answer = formDefinition.answers.find(fda => fda.valueId === answerValueId);
  if (answer) {
    if (imageToEdit) {
      if (answer.images?.length === 0) {
        return formDefinition.formDefinitionId === formDefinitionId;
      }
      return answer.images;
    }
    return true;
  } else {
    return false;
  }
};

export const getOtherAnswer = (formDefinition, imageToEdit) => {
  const otherAnswer = formDefinition.answers.find(answer => {
    const isOtherAnswer = answer.valueId === 12 || (answer.value && answer.value.substring(0, 5) === 'Other');
    const isChecked = multiSelectIsChecked(formDefinition, imageToEdit, answer.valueId, null);

    return isOtherAnswer && isChecked;
  });

  return otherAnswer;
};

export const createSelectOptions = formDefinition =>
  formDefinition.answerTriggers
    .map((at, i) => {
      return { value: at.answerValueId, label: at.answerValue };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

export const removeChildAnswers = (formDefinition, answerValueId, multiSelect, dispatch, removeAnswers) => {
  let formDefinitionsWithAnswersToRemove = formDefinition.children?.filter(cfd =>
    formDefinition.answerTriggers.some(
      at =>
        (multiSelect ? answerValueId == at.answerValueId : !(answerValueId == at.answerValueId)) &&
        at.triggerToFormDefinitionId === cfd.formDefinitionId &&
        !formDefinition.answerTriggers.every(
          at => at.triggerToFormDefinitionId === formDefinition?.answerTriggers[0].triggerToFormDefinitionId,
        ),
    ),
  );
  if (formDefinitionsWithAnswersToRemove?.length > 0) {
    const checkForChildFormDefinitions = fd => {
      if (fd.children?.length > 0) {
        formDefinitionsWithAnswersToRemove = [...formDefinitionsWithAnswersToRemove, ...fd.children];
        fd.children.forEach(cfd => {
          checkForChildFormDefinitions(cfd);
        });
      }
      dispatch({
        type: 'UPDATE_ANSWERS',
        questionId: fd.questionId,
        newAnswers: [],
        orderFormHeaderId: fd.orderFormHeaderId,
      });
    };

    formDefinitionsWithAnswersToRemove.forEach(fd => {
      checkForChildFormDefinitions(fd);
    });

    const childAnswers = formDefinitionsWithAnswersToRemove.map(fd => fd.answers).flat();
    removeAnswers(childAnswers);
  }
};
